// Mirrors backend services/churn_sms_sender.sms_parts — keep in sync.
export const SMS_PART = 320;
export const SMS_TOTAL_MAX = 600;

export const smsParts = (raw) => {
  const text = (raw || "").trim();
  if (text.length <= SMS_PART) return [text];
  const room = SMS_PART - 6;
  let breaks = [...text.matchAll(/[.!?…](?=\s)|\n/g)].map((m) => m.index + 1);
  if (!breaks.length) breaks = [...text.matchAll(/ /g)].map((m) => m.index);
  const ok = breaks.filter((i) => i <= room && text.length - i <= room);
  const i = ok.length ? ok.reduce((a, b) => (Math.abs(b - text.length / 2) < Math.abs(a - text.length / 2) ? b : a)) : text.lastIndexOf(" ", room);
  return [`${text.slice(0, i).trimEnd()} (1/2)`, `${text.slice(i).trim()} (2/2)`];
};
